export const ENTITY_LIMITS_TABLE_COPY = {
	ITEM: 'Item',
	LIMIT: 'Limit',
	PERCENT_USED: '% Used',
	USAGE: 'Usage'
};
